<div class="dropdown-body__item">
  <i class="{{icon}}" *ngIf="icon"></i>
  <span>{{name}}</span>
</div>